export var AppContentType;
(function (AppContentType) {
    AppContentType["Fluid"] = "fluid";
    AppContentType["Draft"] = "draft";
    AppContentType["MOS"] = "mos";
    AppContentType["WAC"] = "wac";
})(AppContentType || (AppContentType = {}));
//# sourceMappingURL=AppContentType.js.map